import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { useParams } from 'react-router'
import { fetchApplications } from '../../../../actions/application';
import { hasOrgBoundRole } from '../../../../utils';
import { getUserDetails } from '../../../../reducers/portalConfig';
import { getApplicationsListResults, getApplicationsListTotalElements, getApplicationsListTotalPages, getIsLoading } from '../../../../reducers/application';
import { getI18n, getI18nFormattedMessage } from '../../../../utils/intl';
import ListContainer from '../../../list';
import styles from '../Apis/styles'
import { Link, makeStyles } from '@material-ui/core';
import { ANY, APPLICATION_LIST_STATUS_BY, APPLICATION_STATUS_DELETE_FAILED, APPLICATION_STATUS_DELETE_PENDING_APPROVAL, APPLICATION_STATUS_DISABLED, APPLICATION_STATUS_EDIT_PENDING_APPROVAL, APPLICATION_STATUS_ENABLED, APPLICATION_STATUS_INCOMPLETE, APPLICATION_STATUS_PENDING_APPROVAL, APPLICATION_STATUS_REJECTED, GRID_ROWS_PER_PAGE_DEFAULT_OPTION } from '../../../../constants';
import { useIntl } from 'react-intl';
import { FormSelect, FormTextField } from '../../../../components';
import clsx from 'clsx';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { lowerCase, startCase } from 'lodash';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

export const Applications = (props) => {
  const {
    setCurrentTab,
    apiGroupUuid,
    userContext,
    applicationsResults,
    applicationsTotalElements,
    applicationsTotalPages,
    isLoading,
    fetchApplications,
  } = props

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
  const [filterByApplicationName, setFilterApplicationName] = useState('');
  const [appliedFilterByApplicationName, setAppliedFilterApplicationName] = useState('');
  const [filterByOrgName, setFilterByOrgName] = useState('');
  const [appliedFilterByOrgName, setAppliedFilterByOrgName] = useState('');
  const [filterByStatus, setFilterByStatus] = useState(ANY);

  const [payload, setPayload] = useState({
    page: page,
    rowsPerPage: rowsPerPage,
    name: filterByApplicationName,
    orgName: filterByOrgName,
    status: filterByStatus,
  })

  const params = useParams();
  const currentTab = params?.tabName;
  const isCurrentTab = currentTab === 'applications'

  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const intl = getI18n(useIntl());

  useEffect(() => {
    if (isCurrentTab) {
      setPage(0);
      setCurrentTab('add-api-group-applications-tab')
    }
  }, [currentTab])

  const getStatusColorClass = (status, classes) => {
    switch (status) {
      case APPLICATION_STATUS_ENABLED:
        return classes.available;
      case APPLICATION_STATUS_PENDING_APPROVAL:
      case APPLICATION_STATUS_EDIT_PENDING_APPROVAL:
      case APPLICATION_STATUS_DELETE_PENDING_APPROVAL:
        return classes.pending;
      case APPLICATION_STATUS_REJECTED:
      case APPLICATION_STATUS_INCOMPLETE:
      case APPLICATION_STATUS_DELETE_FAILED:
        return classes.rejected;
      case APPLICATION_STATUS_DISABLED:
        return classes.disabled;
    }
  };

  const formatAppStatus = (status, classes) => {
    return (
      <span className={classes.statusField}>
        <FiberManualRecordIcon
          className={clsx(classes.statusIcon, getStatusColorClass(status, classes))} />
        <span className={classes.statusText}>{startCase(lowerCase(status))}</span>
      </span>);
  }

  const getListColumns = ({ getI18nFormattedMessage }) => [{
    id: 'name',
    label: getI18nFormattedMessage("label.api.keys.application.name"),
    minWidth: 200,
    format: (item) => {
      return (
        (<Link underline="none" className={classes.link} href={`/admin/console/applications/details/${item.uuid}`} target='_blank'>
          {item.name}
        </Link>)
      )
    },
    value: ({ name, uuid } = {}) => ({ name, uuid }),
  },
  {
    id: 'organizationName',
    label: getI18nFormattedMessage("label.applicaiton.list.page.organization.name.column"),
    minWidth: 200,
  },
  {
    id: 'status',
    label: getI18nFormattedMessage("label.api.groups.add.application.tab.status.text"),
    minWidth: 200,
    value: (item) => formatAppStatus(item.status, classes),
  },
  ];

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    setPayload({ ...payload, page: newPage })
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setPayload({ ...payload, size: newRowsPerPage })
  };

  const onFilterByStatusChange = (newStatus) => {
    setFilterByStatus(newStatus);
    setPayload({ ...payload, status: newStatus });
  }

  const handleChange = (value, filterType) => {
    switch (filterType) {
      case 'filterByApplicationName':
        setFilterApplicationName(value);
        break;
      case 'filterByOrgName':
        setFilterByOrgName(value);
        break;
      default:
        break;
    }
  };

  const applyFilter = (filterType, value, appliedValueKey, payloadKey) => {
    if (value !== appliedValueKey) {
      setPage(0);
      setPayload({ ...payload, [payloadKey]: value });
    }
    switch (filterType) {
      case 'filterByApplicationName':
        setAppliedFilterApplicationName(value);
        break;
      case 'filterByOrgName':
        setAppliedFilterByOrgName(value);
        break;
      default:
        break;
    }
  };

  const handleKeyPress = (e, filterType, value, appliedValueKey, payloadKey) => {
    if (e.key === 'Enter') {
      applyFilter(filterType, value, appliedValueKey, payloadKey);
    }
  };

  const handleBlur = (filterType, value, appliedValueKey, payloadKey) => {
    applyFilter(filterType, value, appliedValueKey, payloadKey);
  };


  useEffect(() => {
    if (apiGroupUuid) {
      fetchApplications({
        page: page,
        size: rowsPerPage,
        name: filterByApplicationName,
        orgName: filterByOrgName,
        status: filterByStatus,
        apiGroupUuid: apiGroupUuid,
      }, hasOrgBoundRole(userContext));
    }
  }, [payload, apiGroupUuid])

  const formSelectContainer = clsx(classes.formSelectContainer, classes.applicationsFormSelect)

  return (
    <div>
      {
        applicationsResults &&
        <ListContainer
          listPageId='add-api-group-applications-list'
          showListHeader={true}
          isLoading={isLoading}
          noResultsMessage={getI18nFormattedMessage('label.no.results')}
          filterAndSortContent={
            <div className={classes.applicationFiltersContainer}>
              <FormTextField
                name={intl.getI18nMessage('label.filter')}
                fieldContainerClass={classes.fieldContainer}
                value={filterByApplicationName}
                placeholder={intl.getI18nMessage('label.application.list.page.filter.by.name.placeholder')}
                handleChange={(value) => handleChange(value, 'filterByApplicationName')}
                onKeyPress={(e) =>
                  handleKeyPress(e, 'filterByApplicationName', filterByApplicationName, appliedFilterByApplicationName, 'name')
                }
                handleBlur={() =>
                  handleBlur('filterByApplicationName', filterByApplicationName, appliedFilterByApplicationName, 'name')
                }
                id="add-api-groups-applications-filter-by-name"
                data-apim-test="add-api-groups-applications-filter-by-name"
              />
              <FormTextField
                {...props}
                fieldContainerClass={classes.fieldContainer}
                id="add-api-groups-applications-filter-by-org-name"
                data-apim-test="add-api-groups-applications-filter-by-org-name"
                name="Filter"
                value={filterByOrgName}
                placeholder={intl.getI18nMessage('label.application.list.page.filter.by.orgname.placeholder')}
                handleChange={(value) => handleChange(value, 'filterByOrgName')}
                onKeyPress={(e) =>
                  handleKeyPress(e, 'filterByOrgName', filterByOrgName, appliedFilterByOrgName, 'orgName')
                }
                handleBlur={() =>
                  handleBlur('filterByOrgName', filterByOrgName, appliedFilterByOrgName, 'orgName')
                }
                hideLabel
              />
              <FormSelect
                {...props}
                id="add-api-groups-applications-filter-by-status"
                data-apim-test="add-api-groups-applications-filter-by-status"
                fieldContainerClass={formSelectContainer}
                name={intl.getI18nMessage('label.filter')}
                value={filterByStatus}
                data={APPLICATION_LIST_STATUS_BY}
                handleChange={onFilterByStatusChange}
                hideLabel
                noNoneOption
                noNativeSelect
              />
            </div>
          }
          columns={getListColumns({ getI18nFormattedMessage })}
          rows={applicationsResults || []}
          totalElements={applicationsTotalElements}
          totalPages={applicationsTotalPages}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          onChangePreviousPage={onChangePreviousPage}
          onChangeNextPage={onChangeNextPage}
          page={page}
          rowsPerPage={rowsPerPage}
          pageClass={classes.listContent}
          pageBodyClass={classes.pageBodyClass}
          pageFilterAndSortClass={classes.pageFilterAndSortClass}
        />
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  userContext: getUserDetails(state),
  applicationsResults: getApplicationsListResults(state),
  applicationsTotalElements: getApplicationsListTotalElements(state),
  applicationsTotalPages: getApplicationsListTotalPages(state),
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  fetchApplications,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(Applications);

Applications.propTypes = {
  setCurrentTab: PropTypes.func,
  apiGroupUuid: PropTypes.string,
  userContext: PropTypes.object,
  applicationsResults: PropTypes.array,
  applicationsTotalElements: PropTypes.number,
  applicationsTotalPages: PropTypes.number,
  isLoading: PropTypes.bool,
  fetchApplications: PropTypes.func,
}
